import Material from 'models/Material';

export default function traduzirNomeMaterial(
  obj: Material,
  limitado = false,
): string {
  return `${obj.codigoSap ?? obj.diteCodigo ?? ''} - ${obj.descricao ?? ''}`;
  // return `${obj.codigoSap ?? ''} - ${obj.descricao ?? ''}`;
}
